module.exports = __webpack_public_path__ + "static/media/inventoryprod_logo.db67e5ec.png";